import crawlApi, {
  type CrawlCountArg,
  type CrawlRequestBody
} from './crawlApi';

const pagesApi = crawlApi.injectEndpoints({
  endpoints: build => ({
    countCrawlPages: build.query<unknown, CrawlCountArg>({
      query: ({ job_page, domain_slug }: CrawlCountArg) => ({
        url: '/khazesh/v3/pages/count',
        method: 'POST',
        body: { job_page, domain_slug }
      })
    }),

    getCrawlPages: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/pages/`,
        method: 'POST',
        body: body
      })
    }),

    insertCrawlToDo: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/pages/insert_todo`,
        method: 'POST',
        body: body
      }),
      invalidatesTags: ['PAGE_ISSUE']
    })
  })
});

export const {
  useCountCrawlPagesQuery,
  useGetCrawlPagesMutation,
  useInsertCrawlToDoMutation
} = pagesApi;

export default pagesApi;
